module.exports = __webpack_public_path__ + "img/11 - Condominio_das_Americas_CasteloDagua.5504150e.jpg";